import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { IStoreMenuCategoryItem, IStoreMenuItem, ITranslatableText } from 'src/app/store/services/store.service';
import { AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { SettingService } from '../../services/setting.service';;
import { IAddress } from '../../services/address.service';
import { DomSanitizer } from '@angular/platform-browser';
//import { IonSlides } from '@ionic/angular';
//import { SwiperComponent } from 'swiper/angular';
//import SwiperCore, { Navigation, Pagination } from 'swiper';
import { IItemDetailCombination, IOrderItem } from 'src/app/store/services/order.service';
import { TranslationService } from '../../services/translation.service';
interface itemDetailCombination 
{
  size: ITranslatableText,
  color: ITranslatableText,
  sizeId: string,
  colorId: string,
  id: string,
  code: string,
  isDeleted: boolean,
  price: number
}

//SwiperCore.use([Navigation, Pagination]);


@Component({
    selector: 'app-menu-item-option-detail-modal',
    templateUrl: './menu-item-option-detail-modal.component.html',
    styleUrls: ['./menu-item-option-detail-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MenuItemOptionDetailModalComponent implements OnInit, AfterViewInit {
  @Input() item: IStoreMenuCategoryItem;
  @Input() optionIndex: number;
  @Input() orderItem: IOrderItem;
  @Input() option: any;
  @Input() chosenQuantity: number;
  @Input() chosenItemDetailCombination: IItemDetailCombination;
  @ViewChildren('img2') img2;
  @ViewChildren('colorCircle') colorCircle;
  @ViewChildren('sizes') sizes;
  @ViewChild('imageContainer') imageContainer: ElementRef;
  @ViewChild('zoomIn') zoomIn: ElementRef;
  //@ViewChild('slider') slides: IonSlides;
  //@ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @ViewChild('swiper', { static: false }) swiperEl?: ElementRef;

  isCombination: Boolean=false;
  propertySelected: boolean=false;

  itemDetailCombination: itemDetailCombination;
  selectedColor: string;
  selectedColorImage={mainImage: '',otherImages: []};
  title: string = "ItemDetail.Details";
  currentLang: string = 'en';
  selectedImage: string=null;
  deliveryAddress: IAddress;
  style1: boolean=false;
  style2: boolean=false;
  newOrder: boolean=false;
  size:any[]= [];
  colors:any[]= [];
  quantity=[1,2,3,4,5,6,7,8,9,10];
  combinationPrice: number=null;
  priceModifier: number = null;
  normalPrice: number;
  @Input() trackStoreId: string;
  selectedQuantity: number=1;
  itemQuantity?: number;
  ecolor="red";
  sizeSelected: boolean = false;

  postError: boolean = false;

  constructor(private modalCtrl: ModalController,
    //public translateService: TranslateService,
    private alertCtrl: AlertController,
    public settingService: SettingService,
    public sanitizer: DomSanitizer,
    public translationService: TranslationService
  ) { }
  ngOnDestroy()
  {
    this.selectedImage=null;
    this.selectedColorImage={mainImage: '',otherImages: []};
  }

  ngOnInit() {    
    this.combinationPrice=null;
    this.priceModifier=null;
    this.normalPrice=this.option.price;
    this.itemDetailCombination={
          size: null,
          color: null,
          sizeId: null,
          colorId: null,
          code: null,
          id: null,
          isDeleted: false,
          price: this.normalPrice
    };

    if(this.option.isInventoryExist)
    {
        this.itemQuantity=null;
    }
    let category = this.item.item.itemOptionCategories[this.optionIndex];
    if(category.isMultiple){
      if(category.multipleLimit){
        this.quantity = [];
        for(let i = 1; i <= category.multipleLimit; i++){
          this.quantity.push(i);
        }
      }
    } else {
      this.quantity = [1];
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      for(let color of this.option.itemColors as any){
        if(!color.isDeleted){
          this.changeColor(color.name, color);
          break;
        }
      }
      if(this.chosenItemDetailCombination){
        let chosenColor = this.option.itemColors.find(color => color.id == this.chosenItemDetailCombination.colorId);
        this.changeColor(chosenColor.name, chosenColor, undefined, chosenColor.id);

        let chosenSize = this.option.itemSizes.find(size => size.id == this.chosenItemDetailCombination.sizeId);
        this.selectSize(chosenSize.abbreviation, undefined, chosenSize.id);
      } else if (this.option.itemDetailCombination){
        for(let i = 0; i < this.option.itemDetailCombination.length; i++){
          if(this.option.itemDetailCombination[i].modifier){
            let chosenColor = this.option.itemColors.find(color => color.id == this.option.itemDetailCombination[i].colorId);
            this.changeColor(chosenColor.name, chosenColor, undefined, chosenColor.id);

            let chosenSize = this.option.itemSizes.find(size => size.id == this.option.itemDetailCombination[i].sizeId);
            this.selectSize(chosenSize.abbreviation, undefined, chosenSize.id);
            break;
          }
        }
      }
      if(this.chosenQuantity){
        this.selectedQuantity = this.chosenQuantity;
        this.quantity = [];
        for(let i = 1; i <= this.chosenQuantity; i++){
          this.quantity.push(i);
        }
      }
    });
  }

  getItemImage(item)
  {
    if ( item.itemImageShortName != "" && item.itemImageShortName != null) {
      return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + item.itemImageShortName) + ')'
    }
  }
  checkQuantity(item=null)
  {   
    let storage=JSON.parse(localStorage.getItem('cartStorage'));
      if(storage)
      {  
        let quantity=0;
        let result=item.quantity;
        if(storage.length>0)
        {
            storage.map(storedItem=>{
              if(storedItem.itemDetailCombination)
              {
                for(let i=0; i < storedItem.options.length; i++){
                  if(item.sizeId===storedItem.options[i].itemDetailCombination.sizeId &&
                    item.colorId===storedItem.options[i].itemDetailCombination.colorId){
                      quantity+=storedItem.options[i].quantity; 
                  }
                }
              }  
              this.itemQuantity=result-quantity;
            })
        }
        else {
          this.itemQuantity=item.quantity;
        }  
      }
      else 
      {
        this.itemQuantity=item.quantity;
      }  
  }

  noQty()
  {
    this.alertCtrl.create({
      header: this.translationService.translate('Menu.OutOfStockTitle'),
      message: this.translationService.translate('Menu.OutOfStock'),
      buttons: [
        {
          text: 'Okay',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then(al=>{
      al.present();
    });
  }
  getColorImage(color)
  {
    if (color.colorImageShortName != null && color.colorImageShortName != "") {
      return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + color.colorImageShortName) + ')';
    }   
  }
  clickedImage(image)
  {
      if(image !=null && image !=null)
    {
      this.selectedImage='url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + image) + ')';
    }
  }
  getColorImages(colorImage)
  {
    if (colorImage != "" && colorImage !=null) {

      return this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + colorImage);
    }   
  }
  zoomSmallImages(image)
  {
    return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + image) + ')'
  }
 
  onStartOrder() {
    if(!this.sizeSelected){
      this.postError = true;
      return;
    }

    if(this.itemQuantity==0 && this.option.isInventoryExist)
    {
      this.noQty();
      return;
    }
    if(this.selectedQuantity>this.itemQuantity)
    {
      this.noQty();
      return;
    }
    this.modalCtrl.dismiss({
      cancel: false,
      back: false,
      itemDetailCombination: this.itemDetailCombination,
      quantity: this.selectedQuantity,
      option: this.option
    });
    
  }
  
  cancel() {
    this.modalCtrl.dismiss({
      cancel: true
    });
    localStorage.removeItem('editKey');
    localStorage.removeItem('editOptionKey')
  }

  quantityChange(e)
  {
    this.selectedQuantity=e.target.value
  }
  private createImageFromBlob(image: Blob, item: IStoreMenuItem) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      item._itemImage = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  track(e: Event)
  {
            const target = e.target as HTMLInputElement;

            if(target.className=="modal-new-cart" || target.id=="no")
            {
              this.newOrder=false;
            }
  } 
  changeImage(image: string, e: Event)
  { 
    let target=e.target as Element;
    //this.slides.slideTo(+target.id);
    //this.swiper?.swiperRef.slideTo(+target.id);
    const swiper = this.swiperEl?.nativeElement.swiper;
    swiper?.slideTo(+target.id);

    let images = this.img2._results;
 
    for(let i = 0;i<images.length;i++)
    {
      images[i].nativeElement.classList.remove('style2');
      if(images[i].nativeElement.id==target.id)
      {
        target.classList.add('style2');
      }
    }
    // don't need because use scroll instead
    // this.clickedImage(image)
  }
  changeColor(color, colorAllProp, e?: Event, chosenColorId?: string): boolean
  { 
    this.initialProperty();
    if(colorAllProp.colorImageShortNames)
    {
      this.selectedColorImage.mainImage=colorAllProp.colorImageShortNames[0];
      this.selectedColorImage.otherImages=[...colorAllProp.colorImageShortNames];
      this.selectedImage='url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + colorAllProp.colorImageShortNames[0]) + ')'
      // don't need above line
      /*
      if(this.slides){
        this.slides.slideTo(0);
      }
      */

      /*
      if (this.swiper?.swiperRef) {
        this.swiper.swiperRef.slideTo(0);
      }
        */
      const swiper = this.swiperEl?.nativeElement.swiper;
      swiper?.slideTo(0);
    }
    else {
      this.selectedColorImage.otherImages.length=0;
      this.selectedColorImage.mainImage='';
      this.selectedImage=null;
    }
    let colors=this.colorCircle._results;
    this.selectedColor=color.translations[localStorage['lang']];

    if(e === undefined && chosenColorId === undefined){
      colors[0].nativeElement.classList.add('selected');
      this.itemDetailCombination.colorId=colors[0].nativeElement.id;
    } else {
      let id = null;
      if (e){
        let target = e.target as Element;
        id = target.id;
      } else if (chosenColorId) {
        id = chosenColorId;
      }
      for(let i=0;i<colors.length;i++)
      {
          if(colors[i].nativeElement.id==id)
          {  
            colors[i].nativeElement.classList.add('selected');
          }
          else
          {
            colors[i].nativeElement.classList.remove('selected');
          }
      }
      this.itemDetailCombination.colorId=id;
    }
    this.itemDetailCombination.color=color;
    this.checkItemDetailCombination();
    return true;
  }
  selectSize(size, e?:Event, chosenSizeId?: string)
  { 
    this.initialProperty();
    let id = null;
    if (e){
        let target = e.target as Element;
        id = target.id;
    } else if (chosenSizeId) {
        id = chosenSizeId;
    }
    let colors=this.sizes._results;
    for(let i=0;i<colors.length;i++)
    {
      if(colors[i].nativeElement.id==id)
      {  
        colors[i].nativeElement.classList.add('selectedSize');
      }
      else
      {
        colors[i].nativeElement.classList.remove('selectedSize');
      }
    }
    this.sizeSelected = true;
    this.postError = false;
    this.itemDetailCombination.size=size;
    this.itemDetailCombination.sizeId=id;
    this.checkItemDetailCombination();
  }

  initialProperty()
  {
    this.isCombination=false;
    this.itemDetailCombination.id="";
    this.itemDetailCombination.code="";
    this.itemDetailCombination.price=this.normalPrice;
    this.combinationPrice=null;
    this.priceModifier=null;
    this.propertySelected=true;
    this.itemQuantity=null;
  }
  

  checkItemDetailCombination()
  {
    
    if(this.option.itemDetailCombination.length>0)
    {
          this.option.itemDetailCombination.map(item=>{

              if(item.sizeId==this.itemDetailCombination.sizeId && item.colorId==this.itemDetailCombination.colorId && !item.isDeleted)
              {
             
                this.isCombination=true;
                this.combinationPrice=item.price;
                this.priceModifier=item.modifier;
                this.itemDetailCombination.isDeleted=item.isDeleted;
                this.itemDetailCombination.id=item.id;
                this.itemDetailCombination.price=(this.priceModifier != null) ? this.priceModifier : this.combinationPrice;
                this.itemDetailCombination.code=item.code;
                this.itemQuantity=item.quantity;
                this.checkQuantity(item);
                
              }
          })    
    }
    else 
    {
      this.combinationPrice=null;
      this.priceModifier=null;
    }
  }
 zoom()
 { 
   let container=this.imageContainer.nativeElement;
   container.classList.add("hide");
   if(this.zoomIn)
   {
    let zoom=this.zoomIn.nativeElement;
    zoom.classList.remove("hide");
   }
 }
 close()
 {
  let container=this.imageContainer.nativeElement;
  container.classList.remove("hide");
  let zoom=this.zoomIn.nativeElement;
  zoom.classList.add("hide");
 }
 openAccordion(e: any)
 {  //View child yet to be configured
    e.target.classList.toggle("active");
    var panel = e.target.nextElementSibling;
    panel.classList.toggle("hide");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
 }
 openTab(){
  window.open("/home", '_blank');
 }
 onSlideChange(){
  /*
  this.slides.getActiveIndex().then(
    (index)=>{
      let images=this.img2._results;
 
      for(let i=0;i<images.length;i++)
      {
        images[i].nativeElement.classList.remove('style2');
        if(images[i].nativeElement.id==index)
        {
          images[i].nativeElement.classList.add('style2');
        }
      }
   });
   */

    /*
    const swiperInstance = this.swiper?.swiperRef; // Swiper instance
    if (swiperInstance) {
      const index = swiperInstance.activeIndex; // synchronous

      const images = this.img2._results;
      for (let i = 0; i < images.length; i++) {
        images[i].nativeElement.classList.remove('style2');
        if (+images[i].nativeElement.id === index) { // make sure to compare numbers
          images[i].nativeElement.classList.add('style2');
        }
      }
    }
    */

    const swiper = this.swiperEl?.nativeElement.swiper;
    if (swiper) {
      const index = swiper.activeIndex;

      const images = this.img2._results;
      for (let i = 0; i < images.length; i++) {
        images[i].nativeElement.classList.remove('style2');
        if (+images[i].nativeElement.id === index) {
          images[i].nativeElement.classList.add('style2');
        }
      }
    }
 }
 backOption() {
  this.option._selected = false;
  this.option.quantity = 0;
  this.modalCtrl.dismiss({
    cancel: false,
    option: this.option,
    back: true,
  });
 }
 skipOption() {
  this.modalCtrl.dismiss({
    cancel: false,
    option: null,
    back: false,
  });
 }
}

